import { render, staticRenderFns } from "./SubClientCreateForm.vue?vue&type=template&id=659cc3be&scoped=true"
import script from "./SubClientCreateForm.vue?vue&type=script&lang=js"
export * from "./SubClientCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659cc3be",
  null
  
)

export default component.exports